import { Icon } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useBreakpoint } from '~/hooks';
import { contextActivitiesMenuItems } from '~activities/ContextMenu/data';
import useIsActivitiesRoot from '~activities/hooks/useIsActivitiesRoot';

const ContextMenu = () => {
  const { t, i18n } = useTranslation('app');
  const { mobileScreen } = useBreakpoint();
  const locale = i18n.language;
  const onActivitiesRoot = useIsActivitiesRoot();
  const { pathname } = useLocation();

  if (mobileScreen && !onActivitiesRoot) {
    return null;
  }

  const isActiveTab = (url: string) => {
    const lastSegment = pathname.split('/').filter(Boolean).pop();
    return lastSegment === url;
  };

  return (
    <div className="flex flex-col gap-x w-full md:w-[200px] px-2x md:px-0">
      {contextActivitiesMenuItems.map((item) => (
        <Link
          key={item.url}
          to={item.url}
          className={[
            'w-full flex justify-between gap-1.5x',
            'border-b md:border-b-0 border-gray_light_1 text-body-1 py-x pb-1.5x md:px-1.5x md:rounded-[8px]',
            'md:hover:bg-blue_light_2 md:hover:text-blue',
            isActiveTab(item.url)
              ? 'bg-blue_light_2 text-blue'
              : 'text-gray__dark_1',
          ].join(' ')}
        >
          <div className="flex gap-1.5x">
            <Icon
              name={item.iconName}
              className="shrink-0 [&_path]:!fill-transparent"
            />
            <span>{t(item.name)}</span>
          </div>
          <Icon
            name={locale === 'ar' ? 'chevron-left' : 'chevron-right'}
            className="text-gray__dark_1 md:hidden"
          />
        </Link>
      ))}
    </div>
  );
};

export default ContextMenu;
